
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-codeHighlighter.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-code-highlighter-demo-codehighlighter"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-codeHighlighter.zh-CN.md?type=demo')
};